import React, { useState }  from 'react';
import classnames from 'classnames';
import { NeuroMessage, useProduct } from '@ignitesales/neuro-application/src/neuro-guide';
import { useNeuroMessages } from '@ignitesales/neuro-application/src/neuro-guide/components';
import ReactSVG from 'react-svg';
import PropTypes from 'prop-types';
import { useAnswers } from '@ignitesales/neuro-application/src/neuro-guide/hooks';
import { PRODUCT_10001_URL_MAP } from '../utils/constants.mjs';
import useProductUrl from '../hooks/useProductUrl';

const Product = ({ product, onClick }) => {
  const {
    description,
    disclosures,
    features,
    name,
    url,
    onProductActionClick
  } = useProduct(product);

  const cssBEM = 'product';
  const messageContext = useNeuroMessages();
  const { getAnswer } = useAnswers();
  const productIcon = messageContext.getMessage(`${product.id}.icon`);
  const productAction = messageContext.getMessage(`${product.id}.actionType`);
  const productUrlClicked = () => onProductUrlClick({ actionName: 'productUrlClicked', value:'learnMore', productId: product.id });
  const isCustomerAnswer = getAnswer('isCustomer');
  const isMember = Object.values(isCustomerAnswer).includes(true);
  const memberUrl = messageContext.getMessage(`${product.id}.actionType.member`);
  const nonMemberUrl = messageContext.getMessage(`${product.id}.actionType.nonMember`);
  const defaultUrl = messageContext.getMessage(`${product.id}.actionType.url`);
  const productButtonMessageId = 'buttonText';
  const productActionUrlCount = messageContext.getMessage(`${product.id}.actionType.url.count`) || 0;
  const customerType = getAnswer('customerType');
  const { getProductUrlByRuleMatch } = useProductUrl();
  const productUrlByMatchedRule = getProductUrlByRuleMatch(customerType, PRODUCT_10001_URL_MAP);

  // productAction 2 is the member vs nonmember URLs in messages
  const productUrl =
        isMember && productAction == '2' ? memberUrl :
        !isMember && productAction == '2' ? nonMemberUrl :
        !!productActionUrlCount ? productUrlByMatchedRule : defaultUrl;

  const onProductClick = () => {
    const actionWords = 'product'+messageContext.getMessage(`${product.id}.actionType.${productButtonMessageId}`).replace(/\s/g, '')+'Clicked';
    onProductActionClick({
      actionName: actionWords
    });
    onClick({
      productId: product.id,
      productAction: productAction,
      productUrl: productUrl
    });
  }

  const productButton = <button
    onClick={ onProductClick }>
    <NeuroMessage id={ `${product.id}.actionType.${productButtonMessageId}` } />
  </button>;

  const renderProductName = () => {
    return name.length ?
    <div className={`${cssBEM}__header`}>
      <ReactSVG src={ productIcon } />
      <h2><a href={ url } target="_blank"><NeuroMessage id={`${product.id}.name`} onClick={productUrlClicked} /></a></h2>
    </div> : null;
  };

  const renderProductDescription = () => {
    if ( description?.props || description?.length) {
      return  <div className={`${cssBEM}__description`}>
           { description?.props?.children || description }
       </div> 
    }
    return null;
  };

  const renderProductFeatures = () => {
    return features.length ?
    <div className={`${cssBEM}__features`}>
      <NeuroMessage id='products.features.title' tagName='div' className='productFeatures__title' />
      <ul>{features.map( (f,i) => <li key={i}>{f}</li>)}</ul>
    </div> : null;
  };

  const renderProductDisclosures = () => {
    return disclosures.length ?
      <div className={`${cssBEM}__disclosures`}>
        <NeuroMessage id='products.disclosures.title'  tagName='div' className='productDisclosures__title' />
        <ul>{disclosures.map( (f,i) => <li key={i}>{f}</li>)}</ul>
      </div> : null;
  };

  return <div className={cssBEM} key={product.id}>
    { renderProductName() }

    { renderProductDescription() }

    { renderProductFeatures() }

    { renderProductDisclosures() }

    <div className={`${cssBEM}__actions`}>
      { productButton }
    </div>

  </div>;
};

Product.propTypes = {
  product: PropTypes.object.isRequired
};

export default Product;
